import React, { useMemo, useState } from "react";

import { SIDEBAR_BEHAVIOR, SIDEBAR_POSITION } from "../constants";
import useSettingsState from "../hooks/useSettingsState";

const initialState = {
  isOpen: true,
  float: false,
  setIsOpen: (open: boolean | ((state: boolean) => boolean)) => {},
  setFloat: (float: boolean) => {},
  setPosition: (position: string) => {},
  setBehavior: (behavior: string) => {},
  position: SIDEBAR_POSITION.LEFT,
  behavior: SIDEBAR_BEHAVIOR.STICKY,
  navItemClicked: 0,
  trackItemClicked: () => {},
};

const SidebarContext = React.createContext(initialState);

interface SidebarProviderType {
  children: React.ReactNode;
}

function SidebarProvider({ children }: Readonly<SidebarProviderType>) {
  const [isOpen, setIsOpen] = useState(window.innerWidth >= 1280);
  const [float, setFloat] = useState(window.innerWidth < 640);

  const [position, setPosition] = useSettingsState(
    "sidebarPosition",
    SIDEBAR_POSITION.LEFT,
  );
  const [behavior, setBehavior] = useSettingsState(
    "sidebarBehavior",
    SIDEBAR_BEHAVIOR.STICKY,
  );
  const [navItemClicked, setNavItemClicked] = useState(0);
  const trackItemClicked = () => setNavItemClicked((prev) => prev + 1);

  const value = useMemo(
    () => ({
      isOpen,
      setIsOpen,
      float,
      setFloat,
      position,
      setPosition,
      behavior,
      setBehavior,
      navItemClicked,
      trackItemClicked,
    }),
    [
      isOpen,
      float,
      position,
      behavior,
      navItemClicked,
      setIsOpen,
      setFloat,
      setPosition,
      setBehavior,
      trackItemClicked,
    ],
  );

  return (
    <SidebarContext.Provider value={value}>{children}</SidebarContext.Provider>
  );
}

export { SidebarContext, SidebarProvider };
